import type { User, Product } from '../../types';
import { getFullImageUrl } from '../storage/publicAssets';

export const mapProfileToUser = (profile: any): User => {
  const avatar = getFullImageUrl(profile.avatar_url || profile.avatarUrl);
  const emailConfirmedAt = profile.email_confirmed_at || null;
  const emailVerified = profile.email_verified === true || !!emailConfirmedAt;
  const phoneVerifiedAt = profile.phone_verified_at || null;
  const phoneVerified = !!phoneVerifiedAt;
  return {
    ...profile,
    avatarUrl: avatar,
    avatar_url: avatar,
    email_verified: emailVerified,
    email_confirmed_at: emailConfirmedAt,
    phone_verified: phoneVerified,
    phone_verified_at: phoneVerifiedAt,
    totalOrders: profile.total_orders || 0,
    totalDeposits: profile.total_deposits || 0,
  } as User;
};

export const mapProductResponse = (p: any): Product => {
  return {
    ...p,
    image_url: getFullImageUrl(p.image_url),
    logo_url: getFullImageUrl(p.logo_url),
    other_images: p.other_images?.map((img: string) => getFullImageUrl(img)) || [],
    categorie_id: p.sub_category?.categorie_id,
    categorie_nom: p.sub_category?.categorie?.nom,
    sub_category_nom: p.sub_category?.nom,
  };
};
